module.exports = __webpack_public_path__ + "img/face-with-monocle.702c3ad0.png";